<template>
    <div>
        <v-dialog v-model="dialog_add_bom" no-click-animation persistent max-width="400" scrollable transition="dialog-bottom-transition">
          <v-card flat>
            <v-toolbar flat noshadow :height="56">
                <v-toolbar-side-icon @click="closeDialogWeb"><v-icon>close</v-icon></v-toolbar-side-icon>
                <v-toolbar-title class="ml-4">Add Raw Material</v-toolbar-title>
            </v-toolbar>
            
            <v-card-text class="pa-0 pt-4">
                <ValidationObserver ref="observer">
                    <v-form full-width>
                        <v-layout wrap ma-0>

                                <v-flex xs12 sm12 md12 form-item>
                                    <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                        <v-autocomplete
                                            :items="$root.products"
                                            v-model="$parent.Form.bomObj.selectedProduct"
                                            @input="$parent.fn_getBomProductDetails($parent.Form.bomObj.selectedProduct.itemId)"
                                            label="Name"
                                            placeholder=" "
                                            item-text="itemName"
                                            item-value="itemId"
                                            return-object
                                            :error-messages="errors"
                                            append>

                                            <v-list-item slot="prepend-item" class="primary--text" @click="fn_newProduct">
                                                <v-list-item-title>Create New</v-list-item-title>
                                            </v-list-item>
                                        </v-autocomplete>
                                    </ValidationProvider>    
                                </v-flex>

                                <v-flex xs6 sm6 md6 pl-4>
                                    <ValidationProvider name="quantity" rules="required|decimal3" v-slot="{ errors }">
                                        <v-text-field
                                            id="bom_qty"
                                            label="Quantity"
                                            placeholder=" "
                                            v-model="$parent.Form.bomObj.qty" 
                                            type="number"
                                            :error-messages="errors"
                                            required
                                        ></v-text-field>
                                    </ValidationProvider>
                                </v-flex>

                                <v-flex xs6 sm6 md6 pl-4 pr-4>
                                    <v-text-field
                                        reaonly
                                        :disabled="true"
                                        label="Unit"
                                        placeholder=" "
                                        :value="$parent.Form.bomObj.unitName"
                                        required
                                    ></v-text-field>
                                </v-flex>

                        </v-layout>

                    </v-form>
                </ValidationObserver>

            </v-card-text>

            <v-card-actions class="pa-0">
              <!-- <v-spacer></v-spacer> -->
              <!-- <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog">close</v-btn> -->
              <!-- <v-btn color="blue darken-1" flat @click.native="$parent.fn_saveRawMaterialItem">Done</v-btn> -->
                <v-layout row wrap ma-0 style="background:#ddd;">
                    <v-flex xs6 sm6 md6>
                        <v-btn style="height:48px !important" nomargin block no-round-borders noshadow @click="fn_checkValidation('new')">Done &amp; New</v-btn>
                    </v-flex>
                    <v-flex xs6 sm6 md6>
                        <v-btn style="height:48px !important" color="primary" nomargin text block no-round-borders noshadow @click="fn_checkValidation(null)">Done</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'

extend('decimal3', value =>     {

  let decimalCount = 0;
  if(Math.floor(value) != value){
     decimalCount = value.toString().split(".")[1].length || 0;
  }

  if(decimalCount <= 3){
    return true;
  }

  return 'This field must be numeric and may contain 3 decimal points.';

})

export default{
    data(){	
        return{
            dialog_add_bom: false
        }
    },
    components:{
        ValidationProvider,
        ValidationObserver
    },
    methods:{
        openDialogWeb: function () {	
            if(!this.dialog_add_bom){
                this.dialog_add_bom = true;
            }
        },
        closeDialogWeb: function () {
            this.dialog_add_bom = false;
        },
        fn_newProduct: function(){
            this.closeDialogWeb();
            this.$router.push({path:'/'+this.$route.params.businessId + '/' + this.$route.params.listId +'/product/items/new', query:{tagId:this.guidWeb(), ls:1}});
        },
        fn_checkValidation: function(type){
            // this.$parent.fn_saveBomItem(type);
            this.$refs.observer.validate().then((result) => {
                if(result){
                    this.$parent.fn_saveBomItem(type);
                }
            })
        }
        
    }
}
</script>